<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" :visible.sync="dialogVisible" destroy-on-close title="合并账户" width="900px" @close="handleClose">
		<div slot="title" class="dialog-title flexStart">
			<h5>合并账户</h5>
			<p>当前微信已被绑定，请合并账户。</p>
		</div>
		<div>
			<el-form ref="formRef" :model="form" :rules="rules" label-position="top" label-width="120px">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="被合并账户ID：" prop="oldConsumerCode">
							<el-input v-model.trim="form.oldConsumerCode" placeholder="请输入被合并账户ID" maxlength="30" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="备注：" prop="replaceInfo">
							<el-input v-model.trim="form.replaceInfo" type="textarea" placeholder="请输入备注" show-password />
						</el-form-item>
					</el-col>
				</el-row>
				<!-- <el-row :gutter="20">
					<el-col :span="24">
						<div class="tips">
							<el-alert
								title="合并说明"
								type="error"
								:closable="false"
								description="合并后，被合并账户的数据将迁移到当前账户，被合并账户将被注销。此操作不可逆，请谨慎操作！"
								show-icon>
							</el-alert>
						</div>
					</el-col>
				</el-row> -->
			</el-form>
			<div class="info-card-desc">
				<h4>操作说明</h4>
				<div class="desc-section">
					<!-- <div class="desc-title">
							<i class="el-icon-s-custom"></i>
							<span>合并账户</span>
						</div> -->
					<div class="desc-content">
						<p>适用于：已注册微信小程序账户，希望与当前web端账户合并的用户</p>
						<p>操作步骤：</p>
						<ol>
							<li>打开特规通微信小程序,进入「企业中心」</li>
							<li>复制您的「用户ID」</li>
							<li>返回本页面,点击「合并账户」并粘贴用户ID</li>
						</ol>
						<p class="desc-warning"><i class="el-icon-warning-outline"></i>合并后,小程序端账户历史将迁移至本账户</p>
					</div>
				</div>
			</div>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取消</el-button>
				<el-button size="small" type="primary" :loading="loading" @click="handleConfirm"> 确认合并 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import TMessage from '@/utils/TMessage';
import { mapGetters } from 'vuex';
import { postMemberReplaceConsumer } from '@/api/user/user.js';

export default {
	name: 'DialogMergeAccount',
	data() {
		return {
			dialogVisible: false,
			loading: false,
			form: {
				oldConsumerCode: '',
				newConsumerCode: '',
				replaceInfo: ''
			},
			rules: {
				oldConsumerCode: [{ required: true, message: '请输入被合并账户ID', trigger: 'blur' }],
				replaceInfo: [{ required: true, message: '请输入合并备注(例如：我同意合并账户)', trigger: 'blur' }]
			}
		};
	},
	computed: {
		...mapGetters('User', ['uinfo'])
	},
	watch: {
		dialogVisible(val) {
			if (!val) {
				this.resetForm();
			}
		}
	},
	methods: {
		handleClose() {
			this.resetForm();
			this.$emit('cancel');
		},

		resetForm() {
			this.$refs['formRef'].resetFields();
			this.loading = false;
		},

		handleConfirm() {
			this.$refs['formRef'].validate(valid => {
				if (valid) {
					this.mergeAccount();
				}
			});
		},

		// 合并账户
		mergeAccount() {
			this.form.newConsumerCode = this.uinfo.consumerCode;
			// 检查是否合并自己的账户
			if (this.form.oldConsumerCode === this.uinfo.consumerCode) {
				TMessage.warning('不能合并当前登录的账户');
				return;
			}

			this.loading = true;

			postMemberReplaceConsumer(this.form)
				.then(res => {
					this.loading = false;
					let { code, data, msg } = res;
					if (code == 200) {
						TMessage.success('账户合并成功');
						this.$emit('confirmInfo');
					} else if (msg) {
						TMessage.warning(msg);
					} else {
						TMessage.warning('账户合并失败');
					}
				})
				.catch(err => {
					this.loading = false;
					TMessage.error('网络错误，请稍后重试');
					console.error('合并账户失败:', err);
				});
		}
	}
};
</script>

<style lang="less" scoped>
.dialog-title {
	h5 {
		line-height: 24px;
		font-size: 18px;
		color: #334155;
		margin: 0;
	}

	p {
		color: #ef4444;
		font-size: 17px;
		margin: 0;
		margin-left: 30px;
	}
}
.info-card-desc {
	margin-top: 24px;
	background: #f8fafc;
	border-radius: 12px;
	padding: 20px 24px;

	h4 {
		margin: 0 0 20px 0;
		font-weight: 600;
		font-size: 16px;
		color: #334155;
		border-bottom: 1px dashed #e2e8f0;
		padding-bottom: 12px;
	}

	.desc-section {
		margin-bottom: 24px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.desc-title {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
		font-size: 15px;
		font-weight: 600;
		color: #334155;

		i {
			margin-right: 8px;
			font-size: 16px;
			color: #155dfc;
		}
	}

	.desc-content {
		// padding-left: 24px;

		p {
			color: #475569;
			margin: 0 0 8px 0;
			line-height: 1.6;
			font-size: 14px;
		}

		ol,
		ul {
			margin: 8px 0;
			padding-left: 20px;
			color: #475569;
			font-size: 14px;

			li {
				margin-bottom: 6px;
				line-height: 1.6;
			}
		}

		.delete-list {
			list-style-type: disc;
			padding-left: 20px;

			li {
				position: relative;
				padding-left: 0;
				margin-bottom: 4px;

				&::before {
					display: none;
				}
			}
		}
	}

	.desc-warning {
		color: #d97706;
		font-size: 13px;
		margin-top: 12px;
		padding: 8px 12px;
		background: #fdf6ec;
		border-radius: 4px;
		border-left: 3px solid #d97706;

		i {
			margin-right: 4px;
		}
	}

	.desc-danger {
		color: #ef4444;
		font-size: 13px;
		margin-top: 12px;
		padding: 8px 12px;
		background: #fef0f0;
		border-radius: 4px;
		border-left: 3px solid #ef4444;

		i {
			margin-right: 4px;
		}
	}
}
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}

.tips {
	margin-top: 20px;
}
</style>